import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MetaInfoDescription } from './MetaInfoDescription';
import { DateFormat, DateFormats } from '../../DateFormat';
import { PersonLink } from './PersonLink';
import ILink from '../../../../types/ILink';

export function EditDateMetaInfo({
  editDate,
  editedBy,
  format,
}: {
  editDate: string;
  editedBy?: ILink;
  format?: DateFormats;
}) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <MetaInfoDescription term={t(`lastEdit`)}>
      <p>
        {t('on')} <DateFormat date={editDate} format={format} />
        {editedBy && (
          <>
            {' '}
            {t('from')} <PersonLink person={editedBy} />
          </>
        )}
      </p>
    </MetaInfoDescription>
  );
}
